import { yupResolver } from "@hookform/resolvers/yup";
import { Modal, Button } from "antd";
import { cancelTripRequestByIdApi } from "api/tripRequest";
import LabeledInput from "components/Form/LabeledInput";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ICancelTripRequest, ITripRequest } from "models/tripRequest";
import { useState } from "react";
import { useForm } from "react-hook-form";
import cancelTripRequestValidator from "validators/cancelTripRequest.validator";

interface IProp {
  open: boolean;
  tripRequest: ITripRequest;
  handleClose: () => void;
}

export default function CancelTripRequestModal({
  open,
  tripRequest,
  handleClose,
}: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadTripRequests } = useDataLoadingContext();
  const { control, handleSubmit } = useForm<ICancelTripRequest>({
    resolver: yupResolver(cancelTripRequestValidator),
  });

  const onSubmit = async (input: ICancelTripRequest) => {
    setLoading(true);
    const { data, error } = await cancelTripRequestByIdApi(
      tripRequest.id,
      input
    );
    if (data) {
      showSuccess("Trip Request Cancelled successfully");
      loadTripRequests();
      setLoading(false);
      handleClose();
    } else {
      showError(error!.message);
      setLoading(false);
    }
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-full text-center">
          <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
            <WarningIcon />
          </div>
          <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
          <p
            className="font-normal text-base"
            style={{ color: "rgba(0,0,0,.64)" }}
          >
            You're about to cancel this trip request
          </p>
          <div className="w-full mt-2 text-start">
            <LabeledInput
              name="reason"
              type="text"
              label="Reason for banning"
              placeholder="Enter reason"
              control={control}
            />
          </div>
          <div className="w-full flex mt-7 items-center justify-end gap-x-3">
            <Button onClick={handleClose}>Cancel</Button>
            <Button htmlType="submit" loading={loading} type="primary">
              Confirm
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
